import React from "react";

import {
    Platform,
    TouchableOpacity, 
    TouchableOpacityProps,
    ViewStyle
} from "react-native";

import AppTheme from "../../utils/Theme";
import SVGView from "../../utils/SvgView";
import Style from "../../utils/Style";
import { SvgProps } from "react-native-svg";

interface SVGIconButtonProps extends TouchableOpacityProps {
    Icon: React.FC<SvgProps>,
    color?: string,
    style?: ViewStyle,
    backgroundColor?: string,
    buttonSize?: number,
    shadow?: boolean
}

const SVGIconButton = (props:SVGIconButtonProps) => {

    const appTheme: AppTheme = new AppTheme();
    const { shadow = true, Icon, color = appTheme.navigationColor, backgroundColor = appTheme.white, buttonSize = Platform.OS === "web" ? appTheme.pixelPerfect(50) : appTheme.pixelPerfect(30), style, ...restProps } = props;
    
    const buttonStyle: ViewStyle = {
        backgroundColor, 
        width: buttonSize, 
        height: buttonSize, 
        borderRadius: buttonSize/2, 
        justifyContent: "center", 
        alignItems: "center"
    }

    let buttonStyles: ViewStyle[] = [];
    if (shadow === true) {
        buttonStyles.push(Style.shadowed);
    }
    buttonStyles.push(buttonStyle);
    buttonStyles.push(style);

    return <TouchableOpacity style={buttonStyles} {...restProps}>
        <SVGView Component={Icon} size={appTheme.pixelPerfect(12)} color={color} />
    </TouchableOpacity>
}

export default SVGIconButton;